const SEARCH_ALL = 'dofe-bo/SEARCH_ALL'
const SEARCH_ALL_SUCCESS = 'dofe-bo/SEARCH_ALL_SUCCESS'
const SEARCH_ALL_FAIL = 'dofe-bo/SEARCH_ALL_FAIL'
const SEARCH_ALL_CANCEL = 'dofe-bo/SEARCH_ALL_CANCEL'

const initialState = {
  data: [],
  isLoading: false,
  cancelled: false
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SEARCH_ALL:
      return {
        ...state,
        isLoading: true,
        cancelled: false
      }
    case SEARCH_ALL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.result,
        cancelled: false
      }
    case SEARCH_ALL_FAIL:
      return {
        ...state,
        isLoading: false,
        cancelled: false
      }
    case SEARCH_ALL_CANCEL:
      return {
        ...state,
        isLoading: false,
        cancelled: true,
        data: []
      }
    default:
      return state
  }
}

export const searchAll = searchQuery => ({
  types: [SEARCH_ALL, SEARCH_ALL_SUCCESS, SEARCH_ALL_FAIL],
  promise: client => client.post('api/search?value=' + searchQuery)
})

// "UX cancel" search
export const cancelSearch = () => ({
  type: 'dofe-bo/SEARCH_ALL_CANCEL'
})
